export default __webpack_public_path__ + "static/foret-verte-3cfa3959bdb91f6f0f1b5f9e70a574c6.jpg";